<template>
  <div>
    <jade-alert
      showIcon
      variant="info"
      :title="$t('title')"
    >
      {{ $t('description') }}
    </jade-alert>
  </div>
</template>

<script>
import { JadeAlert } from '@jade'
export default {
  name: 'ConfirmAcquirerAffiliationAlert',

  components: {
    JadeAlert
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "title": "Conclua o cadastro para ativar adquirentes",
    "description": "Para ativar o status da adquirente cadastrada, é preciso finalizar o cadastro e salvar as alterações primeiro. Em seguida, clique em editar e ative o status das adquirentes desejadas."
  },
  "en-US": {
    "title": "Conclua o cadastro para ativar adquirentes",
    "description": "Para ativar o status da adquirente cadastrada, é preciso finalizar o cadastro e salvar as alterações primeiro. Em seguida, clique em editar e ative o status das adquirentes desejadas."
  }
}
</i18n>
